module.exports = __webpack_public_path__ + "img/lazy.475979a8.gif";